'use client';

import { RegisterLink } from "@kinde-oss/kinde-auth-nextjs/components";
import Link from "next/link";
import Image from "next/image";
import CartaAILogo from '@/../public/images/Carta-ai_Logo.png';

export default function CustomRegisterPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 px-4 py-12">
      <Link href="/">
        <div className="relative w-52 h-20 mb-4">
          <Image src={CartaAILogo} alt="Carta AI Logo" fill className="object-contain" />
        </div>
      </Link>
      <div className="max-w-md w-full space-y-8 bg-white dark:bg-gray-800 p-10 rounded-2xl shadow-xl border border-gray-100 dark:border-gray-700">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 dark:text-white">Create Account</h2>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">Join thousands of professionals using Carta AI</p>
        </div>

        <div className="mt-8 space-y-4">
          <RegisterLink
            authUrlParams={{ connection_id: "YOUR_EMAIL_CONNECTION_ID" }}
            className="w-full flex justify-center py-2.5 px-4 rounded-md text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700"
          >
            Register with Email
          </RegisterLink>

          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center"><span className="w-full border-t border-gray-300"></span></div>
            <div className="relative flex justify-center text-xs uppercase"><span className="px-2 bg-white dark:bg-gray-800 text-gray-500">Join with Socials</span></div>
          </div>

          <div className="grid grid-cols-1 gap-3">
             <RegisterLink
              authUrlParams={{ connection_id: process.env.NEXT_PUBLIC_KINDE_GOOGLE_CONNECTION_ID! }}
              className="flex items-center justify-center gap-2 py-2.5 border border-gray-300 rounded-md bg-white hover:bg-gray-50 text-sm font-medium text-gray-700"
            >
              <img src="/images/google_logo.png" alt="Google" className="w-5 h-5" /> Sign up with Google
            </RegisterLink>

            {/* <RegisterLink
              authUrlParams={{ connection_id: process.env.NEXT_PUBLIC_KINDE_FACEBOOK_CONNECTION_ID! }}
              className="flex items-center justify-center gap-2 py-2.5 border border-gray-300 rounded-md bg-[#1877F2] text-sm font-medium text-white hover:bg-[#166fe5]"
            >
              Sign up with Facebook
            </RegisterLink>

            <RegisterLink
              authUrlParams={{ connection_id: process.env.NEXT_PUBLIC_KINDE_X_CONNECTION_ID! }}
              className="flex items-center justify-center gap-2 py-2.5 border border-gray-300 rounded-md bg-black text-sm font-medium text-white hover:bg-gray-900"
            >
              Sign up with X
            </RegisterLink> */}
          </div>
        </div>

        <p className="mt-8 text-center text-sm text-gray-500">
          Already have an account? <a href="/auth/login" className="font-medium text-indigo-600 hover:text-indigo-500">Sign in</a>
        </p>
        <p className="mt-8 text-center text-sm text-gray-500">
          <a href="/" className="font-medium text-indigo-600 hover:text-indigo-500">
            ← Go back to Home Page
          </a>
        </p>
      </div>
    </div>
  );
}